import { useState, useEffect, useMemo } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

/* contexts */
import { Context } from "../../../context/UserContext";

import moment from "moment";
import "moment/locale/pt-br";

import { Stack, Button, Box, Tooltip, IconButton } from "@mui/material";
import { Delete, Edit, Print } from "@mui/icons-material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";

import { ThemeProvider } from "@mui/material";
/* tema customizado*/
import tableThemeCustom from "../../form/tableThemeCustom";
import CustomDialog from "../../layout/CustomDialog";

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";

/* hooks */
import useFlashMessage from "../../../hooks/useFlashMessage";
import { useNavigateParams } from "../../../hooks/useNavigateParams";

import * as EquipeAPI from "../../../api/equipe";
import * as PessoaAPI from "../../../api/pessoa";
import * as TabelaAPI from "../../../api/tabela";
import * as DataListAPI from "../../../api/dataList";

import formStyles from "../../form/Form.module.css";

import DataList from "../../form/DataList";
import Input from "../../form/Input";
import Checkbox from "../../form/Checkbox";
import SelectEmpresa from "../../form/SelectEmpresa";
import Select from "../../form/Select";

function Form({ token, handleSubmit, formData, btnText, caminhoVoltar, OptionsEmpresa }) {
    const [dados, setDados] = useState({});
    const [pessoa, setPessoa] = useState({});
    const [EquipeIntegrantes, setEquipeIntegrantes] = useState([]);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    if (!dados.empresaId) {
        dados.ativo = true;
        dados.empresaId = localStorage.getItem("empresaId");
        dados.tipo = "Produção";
    }

    const [novoColaborador, setNovoColaborador] = useState({
        uuid: null,
        equipeId: dados.id,
        pessoaId: null,
        cargo: null,
        funcao: "Adicionar",
        Pessoa: { CPForCNPJ: null, descricao: null },
        ativo: true,
    });

    // Estado para rastrear a aba ativa
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState("integrantes");

    //abas
    const [tabEnabled, setTabEnabled] = useState({
        cabeçalho: true,
        integrantes: true,
    });
    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva("cabecalho");
                break;
            case 1:
                setGridAtiva("integrantes");
                break;
            default:
                setGridAtiva("cabecalho");
        }
    };

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    const [rowCount, setRowCount] = useState(0);

    //table state
    const [columnFilterFns, setColumnFiltersMode] = useState(
        localStorage.columnFilterFns.length > 2 ? JSON.parse(localStorage.columnFilterFns) : []
    );
    const [columnFilters, setColumnFilters] = useState(
        localStorage.columnFilters.length > 2 ? JSON.parse(localStorage.columnFilters) : []
    );
    const [globalFilter, setGlobalFilter] = useState(
        localStorage.globalFilter.length > 2 ? JSON.parse(localStorage.globalFilter) : ""
    );
    const [sorting, setSorting] = useState(localStorage.sorting.length > 2 ? JSON.parse(localStorage.sorting) : []);
    const [pagination, setPagination] = useState({
        pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
        pageSize: JSON.parse(localStorage.pagination).pageSize || 5,
    });

    //set datalist
    const [OptionsColaborador, setOptionsColaborador] = useState([]);
    const [EnumCargo, setEnumCargo] = useState([]);

    //Select
    const [OptionsTipo, setOptionsTipo] = useState([]);

    //Atualiza o Datalist
    const consultaDatalistColaborador = async (empresaId, filtro, ativo, tipo) => {
        const result = await DataListAPI.dataListColaborador(empresaId, filtro, ativo, tipo);
        return result;
    };

    //Consultas
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);
        if (table === "EquipeIntegrantes") {
            setEnumCargo(result ? result : []);
        } else if (table === "Equipes") {
            setOptionsTipo(result ? result : []);
        }
    };

    useEffect(() => {
        setDados(formData || {});
        setEquipeIntegrantes(formData?.EquipeIntegrantes || []);
        setRowCount(formData?.EquipeIntegrantes?.length || 0);

        consultaEnum("Equipes", "tipo");
        consultaEnum("EquipeIntegrantes", "cargo", dados.tipo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);
    //gridAtiva
    useEffect(() => {
        if (gridAtiva) {
            fetchData(gridAtiva);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, gridAtiva]);
    useEffect(() => {
        consultaEnum("EquipeIntegrantes", "cargo", dados.tipo);
    }, [dados.tipo]);

    useEffect(() => {
        //atualizar a tabela pessoa com as tabels filhas
        setDados((prev) => {
            return {
                ...prev,
                EquipeIntegrantes: EquipeIntegrantes,
            };
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [EquipeIntegrantes]);

    useEffect(() => {
        const fetchData = async () => {
            const result = await PessoaAPI.pessoaById(novoColaborador.pessoaId);

            setNovoColaborador((prev) => ({
                ...prev,
                Pessoa: { CPForCNPJ: result.data.CPForCNPJ, descricao: result.data.descricao },
            }));
        };

        novoColaborador.pessoaId && fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [novoColaborador.pessoaId]);

    //funções para o colaborador
    const fetchData = async (grid) => {
        // Função auxiliar para aplicar filtros e ordenação
        const applyLocalFiltersAndSorting = (data) => {
            // Aplica os filtros e ordenações locais
            let result = data;

            // Exemplo de aplicação de filtro global
            if (globalFilter) {
                result = result.filter((item) => item.name.includes(globalFilter));
            }

            // Aplicar ordenação, filtro de colunas, etc., conforme necessário
            // result.sort(...), result.filter(...), etc.

            return result;
        };

        if (!EquipeIntegrantes.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        let filteredData = [];

        if (dados.id) {
            if (grid === "integrantes") {
                try {
                    EquipeAPI.listarIntegrantes({
                        start: pagination.pageIndex * pagination.pageSize,
                        size: pagination.pageSize,
                        filters: JSON.stringify(columnFilters ?? []),
                        filtersMode: JSON.stringify(columnFilterFns ?? []),
                        globalFilter: globalFilter ?? "",
                        sorting: JSON.stringify(sorting ?? []),
                        equipeId: dados.id,
                    }).then((response) => {
                        setEquipeIntegrantes(response.data);
                        setRowCount(response.meta.totalRowCount);
                    });
                } catch (error) {
                    setIsError(true);
                    console.error(error);
                    return;
                }
            }
        } else {
            if (grid === "integrantes") {
                filteredData = applyLocalFiltersAndSorting(EquipeIntegrantes);
                setEquipeIntegrantes(filteredData);
            }
            filteredData = applyLocalFiltersAndSorting(EquipeIntegrantes);
        }

        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };
    const handleColaborador = async () => {
        if (dados.id) {
            const result = await EquipeAPI.integrantes(novoColaborador);
            if (result.status === 202) {
                setNovoColaborador({
                    ...novoColaborador,
                    uuid: result.data.uuid,
                    funcao: "Editar",
                });
                setFlashMessage("Integrante já consta na EQUIPE?", "error");
                return;
            }
            setFlashMessage(result.data.message, result.data.type);
            if (result.data.type === "success") {
                setEquipeIntegrantes(result.data.integrantes);
            }
        } else {
            if (novoColaborador.funcao.toLowerCase() === "editar") {
                EquipeIntegrantes[novoColaborador.index] = {
                    ...EquipeIntegrantes[novoColaborador.index],
                    ...novoColaborador,
                };
            } else if (novoColaborador.funcao.toLowerCase() === "deletar") {
                EquipeIntegrantes.splice(novoColaborador.index, 1);
            } else {
                try {
                    setEquipeIntegrantes((prevEquipeIntegrantes) => [...prevEquipeIntegrantes, novoColaborador]);
                } catch (error) {
                    console.error("Erro ao adicionar novo colaborador:", error);
                }
            }
        }
        limparNovoColaborador();
    };
    const handleEditarOrDeletar = async (originalRow, row, funcao) => {
        // Define os dados para o novo produto
        const newData = {
            uuid: originalRow.uuid,
            Pessoa: originalRow.Pessoa,
            cargo: originalRow.cargo,

            equipeId: originalRow.equipeId,
            pessoaId: originalRow.pessoaId,

            ativo: originalRow.ativo,
            funcao: funcao,
            index: row,
        };

        // Atualize o estado do novo objeto
        setPessoa(originalRow.Pessoa);
        setNovoColaborador(newData);

        return;
    };
    const limparNovoColaborador = () => {
        setNovoColaborador({
            uuid: null,
            equipeId: dados.id,
            pessoaId: null,
            cargo: null,
            funcao: "Adicionar",
            Pessoa: { CPForCNPJ: null, descricao: null },
            ativo: true,
        });
        setPessoa({});
    };

    async function handleChange(e) {
        const { name, value, checked, type, options, selectedIndex } = e.target;

        if (name.startsWith("Pessoa.")) {
            setPessoa({
                ...pessoa,
                [name.split(".")[1]]: value,
            });

            const result = await consultaDatalistColaborador(dados.empresaId, value, true, null);
            setOptionsColaborador(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id || null;
            setNovoColaborador((prevState) => ({
                ...prevState,
                pessoaId: selectedId,
            }));
        } else if (name.startsWith("novoColaborador.")) {
            const campo = name.split(".")[1];

            setNovoColaborador({
                ...novoColaborador,
                [campo]: type === "checkbox" ? checked : type === "select-one" ? options[selectedIndex].text : value,
            });
        } else {
            setDados({ ...dados, [name]: type === "checkbox" ? checked : value });
        }
    }
    async function handleOnBlur(e) {
        if (e.target.name === "descricao" && btnText === "Cadastrar") {
            //verifica duplicidade
            const duplicidade = await TabelaAPI.duplicidadeDescricao(
                document.getElementById("empresaId").value,
                "Equipe",
                e.target.value
            );

            if (duplicidade?.uuid) {
                setFlashMessage("Registro em duplicidade!", "warning");
                return navigate(`/Equipes/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        handleSubmit(dados);
    };

    const columns = useMemo(
        () => [
            {
                id: "integrantes",
                header: `Integrantes da equipe de plantão`,
                columns: [
                    {
                        accessorKey: "Pessoa.CPForCNPJ",
                        header: "CPF",
                    },
                    {
                        accessorKey: "Pessoa.descricao",
                        header: "Colaborador",
                    },

                    {
                        accessorKey: "cargo",
                        header: "Cargo",
                    },
                    {
                        accessorKey: "ativo",
                        header: "Ativo",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Ativo", value: 1 },
                            { label: "Inativo", value: 0 },
                        ],
                        filterVariant: "select",
                        muiTableBodyCellProps: ({ row }) => ({
                            align: "center",
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.ativo ? "Ativo" : "Inativo";
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [EquipeIntegrantes]
    );
    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <h1>Equipe</h1>
                    <TabList>
                        <Tab disabled={!tabEnabled.cabeçalho} title={"Cabeçalho da equipe"}>
                            Cabeçalho
                        </Tab>
                        <Tab disabled={!tabEnabled.integrantes} title={"Integrantes da equipe"}>
                            Integrantes
                        </Tab>
                    </TabList>
                    <TabPanel>
                        <div>
                            <SelectEmpresa
                                text="Selecione a Empresa"
                                name="empresaId"
                                options={OptionsEmpresa}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.empresaId || ""}
                                required
                                notOptNull={true}
                            />
                            <Input
                                text="Descrição"
                                type="text"
                                name="descricao"
                                placeholder="Equipe"
                                title="Digite o nome da equipe"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.descricao || ""}
                                required={true}
                            />
                            <Select
                                name="tipo"
                                title="Selecione o tipo"
                                text="Tipo"
                                inputWidth="150px"
                                options={OptionsTipo}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.tipo}
                                isEnum={true}
                                notOptNull={true}
                                required={true}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                type="checkbox"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={dados.ativo === true ? "checked" : ""}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div
                            style={{
                                margin: "1em",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "1rem",
                                }}
                            >
                                <DataList
                                    text="Colaborador"
                                    name="Pessoa.descricao"
                                    inputWidth="300px"
                                    filteredOptions={OptionsColaborador}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoa.descricao || ""}
                                />
                                <Select
                                    name="novoColaborador.cargo"
                                    text="Cargo"
                                    options={EnumCargo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoColaborador.cargo}
                                    isEnum={true}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Ativa"
                                    text="Ativo"
                                    name="novoColaborador.ativo"
                                    type="checkbox"
                                    handleOnChange={handleChange}
                                    value={novoColaborador.ativo}
                                    checked={novoColaborador.ativo === true ? "checked" : ""}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparNovoColaborador();
                                    }}
                                    style={{ marginLeft: "10px" }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoColaborador?.funcao?.toLowerCase() === "deletar" ? "error" : "info"}
                                    onClick={() => handleColaborador(novoColaborador)}
                                    disabled={!novoColaborador.pessoaId ? true : false}
                                    style={{ marginLeft: "5px" }}
                                >
                                    {novoColaborador.funcao}
                                </Button>
                            </div>
                            <ThemeProvider theme={theme}>
                                <MaterialReactTable
                                    displayColumnDefOptions={{
                                        "mrt-row-actions": {
                                            muiTableHeadCellProps: {
                                                align: "center",
                                            },
                                            size: 100,
                                        },
                                        "mrt-row-numbers": {
                                            enableColumnOrdering: true, //turn on some features that are usually off
                                            enableResizing: true,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontSize: "1.2rem",
                                                },
                                            },
                                        },
                                        "mrt-row-select": {
                                            enableColumnActions: true,
                                            enableHiding: true,
                                            size: 50,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    enableGlobalFilterModes
                                    //enableColumnResizing
                                    enableColumnOrdering
                                    enableEditing
                                    renderRowActions={({ row, table }) => (
                                        <Box sx={{ display: "flex", gap: "1rem" }}>
                                            <Tooltip arrow placement="top" title="Editar">
                                                <span>
                                                    {" "}
                                                    <IconButton
                                                        onClick={() => {
                                                            handleEditarOrDeletar(row.original, row.index, "Editar");
                                                        }}
                                                        disabled={localStorage.getItem("editar") === "true" ? false : true}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip arrow placement="right" title="Cancelar">
                                                <span>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleEditarOrDeletar(row.original, row.id, "Deletar")}
                                                        disabled={localStorage.getItem("cancelar") === "true" ? false : true}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    )}
                                    renderTopToolbarCustomActions={() => (
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                            }}
                                        >
                                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                                <div>
                                                    {" "}
                                                    <Button
                                                        color="secondary"
                                                        onClick={() => navigate("/TabelaPrecos/CreateOrEdit")}
                                                        variant="contained"
                                                        disabled={
                                                            true
                                                            // localStorage.getItem("incluir") ===
                                                            // "true"
                                                            //     ? false
                                                            //     : true
                                                        }
                                                    >
                                                        Novo
                                                    </Button>
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )}
                                    columns={columns}
                                    data={EquipeIntegrantes}
                                    enableRowSelection
                                    getRowId={(row) => row.uuid}
                                    manualFiltering
                                    manualPagination
                                    manualSorting
                                    muiToolbarAlertBannerProps={
                                        isError
                                            ? {
                                                  color: "error",
                                                  children: "Error loading data",
                                              }
                                            : undefined
                                    }
                                    onColumnFiltersChange={setColumnFilters}
                                    onColumnFilterFnsChange={setColumnFiltersMode}
                                    onGlobalFilterChange={setGlobalFilter}
                                    onPaginationChange={setPagination}
                                    onSortingChange={setSorting}
                                    rowCount={rowCount}
                                    initialState={{
                                        showColumnFilters: true,
                                        density: "compact",
                                        //columnPinning: { left: ["mrt-row-select"] },
                                    }}
                                    state={{
                                        columnFilterFns,
                                        columnFilters,
                                        globalFilter,
                                        isLoading,
                                        pagination,
                                        showAlertBanner: isError,
                                        showProgressBars: isRefetching,
                                        sorting,
                                    }}
                                    //positionToolbarDropZone={"top"}
                                    positionExpandColumn={"first"}
                                    positionActionsColumn={"first"}
                                    positionToolbarAlertBanner="bottom"
                                    localization={MRT_Localization_PT_BR}
                                />
                            </ThemeProvider>
                        </div>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                                Voltar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                disabled={novoColaborador.pessoaId ? true : false}
                            >
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
